import { interfaces } from "inversify";
import { RateLimiter } from "~/modules/ratelimiter/RateLimiter/RateLimiter";
import { RateLimiterOptions } from "~/modules/ratelimiter/RateLimiter/RateLimiterOptions";
import { rateLimiterMapRTTI, rateLimiterRTTI } from "~/modules/ratelimiter/ratelimiter.rtti";

export function createRateLimiter<T extends RateLimiter = RateLimiter>(
    container: interfaces.Container,
    options: RateLimiterOptions
): T {
    const rateLimiters = container.get<Map<string, T>>(rateLimiterMapRTTI);

    let rateLimiter = rateLimiters.get(options.name);
    if (!rateLimiter) {
        rateLimiter = container.get<T>(rateLimiterRTTI);
        rateLimiter.setup(options);
        rateLimiters.set(options.name, rateLimiter);
    }

    return rateLimiter;
}
